import script from "./UserSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSelect.vue?vue&type=script&setup=true&lang=ts"

import "./UserSelect.vue?vue&type=style&index=0&id=1cef353c&lang=scss&scoped=true"
import "./UserSelect.vue?vue&type=style&index=1&id=1cef353c&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cef353c"]])

export default __exports__